/**
 * Lightweight negative-keyword (profanity / cursing) detection for chat
 * messages.
 *
 * Whole-word matched (`\b`) and case-insensitive, so benign words that merely
 * contain a profane substring (e.g. "class" -> "ass") are not flagged. Returns
 * a boolean only -- we deliberately do not surface the matched word so that no
 * verbatim user content leaves the client for analytics.
 *
 * Scope is intentionally limited to common profanity/cursing. Slurs and
 * leetspeak/obfuscation (e.g. "f*ck", "sh1t") are deliberately out of scope.
 */
const NEGATIVE_KEYWORD_PATTERN = /\b(?:fuck(?:ing|ed|er|s)?|motherfucker|shit(?:ty|tiest|head|s)?|bullshit|dumbass|jackass|asshole|ass|bitch(?:es|ing|y)?|cunt|dick(?:head|s)?|cock|bastard|prick|piss(?:ed|ing)?|crap(?:py)?|damn|goddamn|douche(?:bag)?|wtf|wth|ffs|omfg|bollocks|wank(?:er)?|twat)\b/i;
export function matchesNegativeKeyword(text) {
  if (!text) {
    return false;
  }
  return NEGATIVE_KEYWORD_PATTERN.test(text);
}